<template>
  <v-tabs>
    <v-tab>Danish & Donuts</v-tab>
    <v-tab>Loaves & Cakes</v-tab>
    <v-tab>Croissants</v-tab>
    <v-tab>Cookies, Brownies & Bars</v-tab>
    <v-tab>Bagels</v-tab>
    <v-tab-item>
     <Danish />
    </v-tab-item>
     <v-tab-item>
     <Loaves />
    </v-tab-item>
     <v-tab-item>
     <Croissant />
    </v-tab-item>
     <v-tab-item>
     <Cookies />
    </v-tab-item>
      <v-tab-item>
    <Bagels />
    </v-tab-item>
  </v-tabs>
</template>
<script>
import Bagels from './Tab comps/Bagels.vue'
import Danish from './Tab comps/Danish.vue'
import Croissant from './Tab comps/Croissant.vue'
import Loaves from './Tab comps/Loaves.vue'
import Cookies from './Tab comps/Cookies.vue'
export default {
  components:{
    Danish,
    Croissant,
    Loaves,
    Cookies,
    Bagels
  }
  
}
</script>